let _ctx = null;

export function playChime(freq = 660) {
  if (typeof window !== "undefined" && window.__audioOn !== true) return; // respect master mute (absolute)
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!_ctx) _ctx = new AC();
    _ctx.resume?.();
    const t = _ctx.currentTime;
    const osc = _ctx.createOscillator();
    const gain = _ctx.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(freq, t);
    gain.gain.setValueAtTime(0.0001, t);
    gain.gain.exponentialRampToValueAtTime(0.18, t + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.4);
    osc.connect(gain).connect(_ctx.destination);
    osc.start(t);
    osc.stop(t + 0.42);
  } catch (e) {
    /* ignore */
  }
}
